// extracted by mini-css-extract-plugin
export default {"star":"recommendations-ND8F7","star--favourite":"recommendationsS5kSyP"};